export default __webpack_public_path__ + "static/media/img-login.8fe2c091.png";